module.exports = __webpack_public_path__ + "img/intro_tips_pp.e0cd9a0d.png";